import React from 'react';
import { Pane, Text } from '@leverege/ui-elements';
import S from './Detail.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Detail(props) {
  const {
    label,
    value,
    type = 'row'
  } = props;
  if (type === 'row') {
    return /*#__PURE__*/_jsxs(Pane, {
      layout: "flex:rowSpaceBetween",
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "bodySmall",
        className: S.label,
        children: label
      }), /*#__PURE__*/_jsx(Text, {
        variant: "bodySmallBold",
        className: S.value,
        children: value
      })]
    });
  }
  return /*#__PURE__*/_jsxs(Pane, {
    layout: "flex:col",
    children: [/*#__PURE__*/_jsx(Text, {
      variant: "bodySmall",
      children: label
    }), /*#__PURE__*/_jsx(Text, {
      variant: "bodySmallBold",
      children: value
    })]
  });
}